import settings from '@/settings'

const get = (headers) => {
  return fetch(`${settings.apetrusApi}/bandeiras-cartao/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  get
}
